(() => {
  function initITIAVAStickyHeader() {
    const header = document.querySelector('.ita-header');
    if (!header) return;

    const section = header.closest('.shopify-section');
    if (!section) return;

    /* Prevent duplicate initialization */
    if (header.dataset.stickyInitialized === 'true') return;
    header.dataset.stickyInitialized = 'true';

    /* Find the real scrolling parent */
    function getScrollParent(el) {
      let parent = el.parentElement;

      while (parent && parent !== document.body) {
        const style = window.getComputedStyle(parent);
        const overflowY = style.overflowY;

        if (
          (overflowY === 'auto' || overflowY === 'scroll') &&
          parent.scrollHeight > parent.clientHeight
        ) {
          return parent;
        }

        parent = parent.parentElement;
      }

      return window;
    }

    const scroller = getScrollParent(header);

    let headerHeight = 0;
    let originalTop = 0;
    let originalLeft = 0;
    let originalWidth = 0;
    let isSticky = false;

    /* Create a spacer so the page doesn't jump */
    const spacer = document.createElement('div');
    spacer.setAttribute('data-itiava-sticky-spacer', '');
    spacer.style.display = 'none';

    section.parentNode.insertBefore(spacer, section.nextSibling);

    function measure() {
      /* Temporarily return header to normal flow */
      if (isSticky) {
        header.style.position = '';
        header.style.top = '';
        header.style.left = '';
        header.style.width = '';
        header.style.zIndex = '';
      }

      spacer.style.display = 'none';

      const rect = header.getBoundingClientRect();

      headerHeight = rect.height;
      originalTop = rect.top;
      originalLeft = rect.left;
      originalWidth = rect.width;

      if (isSticky) {
        applySticky();
      }
    }

    function applySticky() {
      if (isSticky) return;

      const rect = header.getBoundingClientRect();

      /* Preserve space occupied by header */
      spacer.style.display = 'block';
      spacer.style.height = `${headerHeight}px`;
      spacer.style.width = '100%';

      header.style.position = 'fixed';
      header.style.top = '0px';
      header.style.left = `${rect.left}px`;
      header.style.width = `${rect.width}px`;
      header.style.zIndex = '99999';

      header.classList.add('js-itiava-sticky');
      isSticky = true;
    }

    function removeSticky() {
      if (!isSticky) return;

      header.classList.remove('js-itiava-sticky');

      header.style.position = '';
      header.style.top = '';
      header.style.left = '';
      header.style.width = '';
      header.style.zIndex = '';

      spacer.style.display = 'none';

      isSticky = false;

      measure();
    }

    function getScrollTop() {
      if (scroller === window) {
        return window.scrollY || window.pageYOffset || 0;
      }

      return scroller.scrollTop;
    }

    function onScroll() {
      const scrollTop = getScrollTop();

      /*
       * Header becomes sticky once it reaches the top.
       * If the header originally starts at 0, the small threshold
       * prevents flickering.
       */
      const threshold = Math.max(originalTop, 0);

      if (scrollTop > threshold + 2) {
        applySticky();
      } else {
        removeSticky();
      }
    }

    /* Listen to the actual scrolling element */
    scroller.addEventListener('scroll', onScroll, { passive: true });

    window.addEventListener('resize', () => {
      measure();
    });

    window.addEventListener('orientationchange', () => {
      setTimeout(measure, 100);
    });

    /* Initial measurement */
    setTimeout(measure, 50);
    setTimeout(measure, 300);
    setTimeout(measure, 800);

    /* Handle Shopify Theme Editor section reloads */
    document.addEventListener('shopify:section:load', () => {
      setTimeout(() => {
        headerHeight = header.offsetHeight;
        measure();
      }, 100);
    });

    /* Handle dynamic image/font loading */
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => {
        measure();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initITIAVAStickyHeader);
  } else {
    initITIAVAStickyHeader();
  }
})();